import useCompanies from 'contexts/basicData/useCompanies';
import { BasicFormState } from 'hooks/useForm';
import { IAddress } from 'utils/address';
import { AssignmentField } from '../DetailedCaseFormProvider/types';

export type GetFixedAssignmentTimeFromAddressesProps = {
  fromAddress: IAddress;
  toAddress: IAddress;
};

function useGetFixedAssignmentTimeFromAddresses() {
  const { companies } = useCompanies();

  const getFixedAssignmentTimeFromAddressData = (
    addressData: GetFixedAssignmentTimeFromAddressesProps
  ) => {
    // return null if either from or to address is not set
    if (!addressData.fromAddress || !addressData.toAddress) {
      return null;
    }
    const {
      fromAddress: {
        name: fromName,
        address: fromAddress,
        city: fromCity,
        zip: fromZip,
      },
      toAddress: { name: toName, address: toAddress, city: toCity, zip: toZip },
    } = addressData;

    const eligibleCompanies = companies.filter((c) => !!c.active);

    const fromCompany = eligibleCompanies.find(
      (c) =>
        c.name === fromName &&
        c.address === fromAddress &&
        c.city === fromCity &&
        c.zip === fromZip
    );
    const toCompany = eligibleCompanies.find(
      (c) =>
        c.name === toName &&
        c.address === toAddress &&
        c.city === toCity &&
        c.zip === toZip
    );

    if (fromCompany && toCompany) {
      let result = fromCompany.pricesFromHere.find(
        (price) => price.toCompanyId === toCompany.companyID
      );
      if (!result) {
        // if we didn't find a price from the fromCompany to the toCompany, we try to find a price from the toCompany to the fromCompany
        result = fromCompany.pricesToHere.find(
          (price) => price.fromCompanyId === toCompany.companyID
        );
      }

      return result;
    }

    return null;
  };

  const getFixedAssignmentTimeFromAddresses = (
    formState: BasicFormState<AssignmentField>
  ) => {
    const fromName = formState[AssignmentField.fromName];
    const fromAddress = formState[AssignmentField.fromAddress];
    const fromCity = formState[AssignmentField.fromCity];
    const fromZip = formState[AssignmentField.fromZip];

    const toName = formState[AssignmentField.toName];
    const toAddress = formState[AssignmentField.toAddress];
    const toCity = formState[AssignmentField.toCity];
    const toZip = formState[AssignmentField.toZip];

    const eligibleCompanies = companies.filter((c) => !!c.active);

    const fromCompany = eligibleCompanies.find(
      (c) =>
        c.name === fromName &&
        c.address === fromAddress &&
        c.city === fromCity &&
        c.zip === fromZip
    );
    const toCompany = eligibleCompanies.find(
      (c) =>
        c.name === toName &&
        c.address === toAddress &&
        c.city === toCity &&
        c.zip === toZip
    );

    if (fromCompany && toCompany) {
      let result = fromCompany.pricesFromHere.find(
        (price) => price.toCompanyId === toCompany.companyID
      );
      if (!result) {
        // if we didn't find a price from the fromCompany to the toCompany, we try to find a price from the toCompany to the fromCompany
        result = fromCompany.pricesToHere.find(
          (price) => price.fromCompanyId === toCompany.companyID
        );
      }

      return result;
    }

    return null;
  };
  return {
    getFixedAssignmentTimeFromAddresses,
    getFixedAssignmentTimeFromAddressData,
  };
}

export default useGetFixedAssignmentTimeFromAddresses;
